import { render, staticRenderFns } from "./ButtonCreateDispatch.vue?vue&type=template&id=2310052c&"
import script from "./ButtonCreateDispatch.vue?vue&type=script&lang=ts&"
export * from "./ButtonCreateDispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports